/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetMeQuotasResponse } from '../../models/get-me-quotas-response';

export interface GetMeQuotas$Params {
}

export function getMeQuotas(http: HttpClient, rootUrl: string, params?: GetMeQuotas$Params, context?: HttpContext): Observable<StrictHttpResponse<GetMeQuotasResponse>> {
  const rb = new RequestBuilder(rootUrl, getMeQuotas.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetMeQuotasResponse>;
    })
  );
}

getMeQuotas.PATH = '/me/quotas';
